import { useMemo } from 'react';

import { type WorkspaceAgentComposerAssetPill } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/usePrivateWorkspaceAgentComposerPills';
import { useWorkspaceAgentClipsForClipIds } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentClipsForClipIds';
import { usePrivateWorkspaceAgentPanelComposerPills } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { getWorkspaceAgentGuidedVariantImagePreviewSelection } from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentGuidedVariantImagePreviewSelection';
import {
  getWorkspaceAgentWatermarkImageDimensions,
  getWorkspaceAgentWatermarkMarginPxMax,
  toWorkspaceAgentWatermarkSubjects,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentWatermark';

export const usePrivateWorkspaceAgentWatermarkSelection = () => {
  const { scopePills } = usePrivateWorkspaceAgentPanelComposerPills();
  const assetPills = useMemo(
    () => scopePills.filter((pill): pill is WorkspaceAgentComposerAssetPill => pill.type === 'asset'),
    [scopePills],
  );
  const assetClipIds = useMemo(() => assetPills.map((pill) => pill.versionId), [assetPills]);
  const scopeClips = useWorkspaceAgentClipsForClipIds(assetClipIds);

  return useMemo(() => {
    const subjects = toWorkspaceAgentWatermarkSubjects({
      assets: assetPills,
      clipsByVersionId: new Map(scopeClips.map((clip) => [clip.id, clip])),
    });

    return {
      marginPxMax: getWorkspaceAgentWatermarkMarginPxMax(getWorkspaceAgentWatermarkImageDimensions(subjects)),
      watermarkSelection: getWorkspaceAgentGuidedVariantImagePreviewSelection(subjects),
    };
  }, [assetPills, scopeClips]);
};
